module.exports = __webpack_public_path__ + "static/media/icon_copy.466a371c.svg";